import { FC, ReactElement } from 'react';
import { Td } from '@chakra-ui/react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
export interface CbTableCellTextProps extends BoxProps {
  borderColor?: string;
  text: string;
  textColor?: string;
  leftAdornment?: ReactElement;
  rightAdornment?: ReactElement;
  hasLeftAdornment?: boolean;
  hasRightAdornment?: boolean;
  isBold?: boolean;
  paddingX?: string | number | {
    base: string | number;
    lg: string | number;
  };
  isCentered?: boolean;
  sideText?: string;
  type?: string;
}
const renderSideText = (textToRender?: string, textType?: string): ReactElement => {
  if (textToRender && textType === 'currency') {
    return <Text color="cloud.500">{`($${textToRender})`}</Text>;
  }
  return <Text color="cloud.500" data-sentry-element="Text" data-sentry-component="renderSideText" data-sentry-source-file="CbTableCellText.tsx">{textToRender}</Text>;
};
export const CbTableCellText: FC<CbTableCellTextProps> = ({
  borderColor,
  text,
  textColor = 'text.primary',
  leftAdornment,
  rightAdornment,
  hasLeftAdornment,
  hasRightAdornment,
  isBold,
  paddingX,
  isCentered,
  sideText,
  type,
  ...props
}) => {
  const fontWeight = isBold ? 'bold' : 'normal';
  const justifyContent = isCentered ? 'center' : 'left';
  return <Td color={borderColor} borderRight={borderColor ? '1px solid' : undefined} borderTop="none" borderBottom="none" textAlign="left" maxWidth={48} paddingY={2} paddingX={0} data-sentry-element="Td" data-sentry-component="CbTableCellText" data-sentry-source-file="CbTableCellText.tsx">
      <Flex paddingY={6} paddingX={paddingX || 10} alignItems="center" justifyContent={justifyContent} {...props} data-sentry-element="Flex" data-sentry-source-file="CbTableCellText.tsx">
        {leftAdornment && hasLeftAdornment && <Box marginRight={0}>{leftAdornment}</Box>}
        <Text noOfLines={1} fontSize="16px" color={textColor} fontWeight={fontWeight} data-sentry-element="Text" data-sentry-source-file="CbTableCellText.tsx">
          {text}
        </Text>
        {rightAdornment && hasRightAdornment && <Box marginLeft={0}>{rightAdornment}</Box>}
        {sideText && <Box marginLeft={0}>{renderSideText(sideText, type)}</Box>}
      </Flex>
    </Td>;
};